import { render } from "./cpt-combination-page-option.vue?vue&type=template&id=7d10bfd4"
import script from "./cpt-combination-page-option.vue?vue&type=script&lang=js"
export * from "./cpt-combination-page-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__